import { useCallback } from 'react';
import logoutObserver from '@/observers/LogoutObserver';
import { useAPI } from '@/services';
import { useRegisterLimitations } from '@/modules/register/hooks/useRegisterLimitations';

const useLogout = () => {
  const { logoutLink } = useRegisterLimitations();
  const { mutateAsync: logoutMutate, isLoading } = useAPI(
    ['user', 'logoutToken'],
    { isMutation: true }
  );
  const logout = useCallback(() => {
    logoutMutate(null).then(() => {
      logoutObserver.notify(null);
      window.location.href = logoutLink();
    });
  }, []);

  return { logout, isLoading };
};

export { useLogout };
